export default __webpack_public_path__ + "static/media/bootcamper.bbbe4f11.mp4";